<!-- Page Header -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-users"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<div class="page-body">
  <div class="table-card">
    <div class="card-header">
      <div class="card-header-icon table-icon">
        <i class="pi pi-users"></i>
      </div>
      <span class="card-header-title">{{ usuariosTexts.titulo }}</span>
    </div>

    <div class="card-content">
      <div class="search-bar">
        <p-iconField iconPosition="right" class="search-field">
          <p-inputIcon styleClass="pi pi-search" />
          <input pInputText type="text"
            [placeholder]="usuariosTexts.pesquisar"
            [(ngModel)]="filtroUsuario"
            (ngModelChange)="onSearchUsuarioChange($event)" />
        </p-iconField>

        <app-column-selector
          [columns]="colunasUsuarios"
          [storageKey]="STORAGE_KEY_USUARIOS"
          (columnsChange)="onColunasUsuariosChange($event)">
        </app-column-selector>
      </div>

      <p-table [value]="usuarios" [loading]="usuariosLoading"
        (onSort)="onSortUsuarios($any($event))"
        [sortField]="usuariosLastfield" [sortOrder]="usuariosLastSort === 'asc' ? 1 : -1"
        [tableStyle]="{ 'width': '100%' }">

        <ng-template pTemplate="header">
          <tr>
            <th [hidden]="!isColunaUsuarioVisivel('nome')" style="width: 26%">
              {{ usuariosTexts.usuario }}
            </th>
            <th [hidden]="!isColunaUsuarioVisivel('email')" pSortableColumn="email" style="width: 25%">
              {{ labels.email }}<p-sortIcon [field]="'email'"></p-sortIcon>
            </th>
            <th [hidden]="!isColunaUsuarioVisivel('empresa')" style="width: 25%">
              {{ usuariosTexts.empresa }}
            </th>
            <th [hidden]="!isColunaUsuarioVisivel('situacao')" pSortableColumn="ativo" style="width: 10%">
              {{ usuariosTexts.situacao }}<p-sortIcon [field]="'ativo'"></p-sortIcon>
            </th>
            <th [hidden]="!isColunaUsuarioVisivel('criadoEm')" pSortableColumn="criadoEm" style="width: 12%">
              {{ labels.data_inclusao }}<p-sortIcon [field]="'criadoEm'"></p-sortIcon>
            </th>
            <th [hidden]="!isColunaUsuarioVisivel('acoes')" style="width: 8%">{{ labels.acoes }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-usuario>
          <tr class="empresa-row" (click)="abrirEmpresaDoUsuario(usuario)">
            <td [hidden]="!isColunaUsuarioVisivel('nome')">
              <span class="empresa-nome">{{ usuario.nome || usuario.username }}</span>
              <span class="tag-master" *ngIf="usuario.categoriaAcessoMaster">
                {{ usuariosTexts.master }}
              </span>
            </td>
            <td [hidden]="!isColunaUsuarioVisivel('email')">{{ usuario.email }}</td>
            <td [hidden]="!isColunaUsuarioVisivel('empresa')">{{ usuario.empresaNome || '-' }}</td>
            <td [hidden]="!isColunaUsuarioVisivel('situacao')">
              <span class="status-badge" [class.status-badge--ativo]="usuario.ativo">
                {{ usuario.ativo ? usuariosTexts.ativo : usuariosTexts.inativo }}
              </span>
            </td>
            <td [hidden]="!isColunaUsuarioVisivel('criadoEm')">
              <div class="date-cell">
                <i class="pi pi-calendar"></i>
                {{ usuario.criadoEm | date: 'dd/MM/yyyy' }}
              </div>
            </td>
            <td [hidden]="!isColunaUsuarioVisivel('acoes')" class="actions" (click)="$event.stopPropagation()">
              <button pButton icon="pi pi-arrow-right"
                class="p-button-text p-button-rounded p-button-sm action-btn select-btn"
                [pTooltip]="tooltips.abrir_empresa_do_usuario" tooltipPosition="top"
                (click)="abrirEmpresaDoUsuario(usuario)">
              </button>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="colunasUsuariosVisiveis" class="text-center p-5">
              <div class="flex flex-column align-items-center">
                <i class="pi pi-users text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
                <div class="text-gray-500 text-lg">{{ usuariosTexts.nenhum }}</div>
                <div class="text-gray-400 text-sm mt-1">{{ usuariosTexts.dica_busca }}</div>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="loadingbody">
          <tr>
            <td [attr.colspan]="colunasUsuariosVisiveis" class="text-center p-5">
              <div class="flex justify-content-center align-items-center">
                <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
                <span class="ml-3">{{ usuariosTexts.carregando }}</span>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <div class="pagination-container">
        <div>
          <p-paginator (onPageChange)="onUsuariosPageChange($any($event))"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} de {totalRecords}"
            [first]="usuariosFirst" [rows]="usuariosRows"
            [totalRecords]="usuariosTotal"
            [showFirstLastIcon]="true">
          </p-paginator>
        </div>
        <div class="flex align-items-center">
          <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
          <p-dropdown [options]="pageSizeOptions" optionLabel="label"
            optionValue="value" [(ngModel)]="usuariosRows"
            (ngModelChange)="onUsuariosRowsPerPageChange()" styleClass="w-6rem">
          </p-dropdown>
        </div>
      </div>
    </div>
  </div>
</div>

<p-toast></p-toast>
